import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  height: 56px;
  margin-left: 5px;
  padding: 8px;
  background-color: rgba(${ColorPalette.RGB.PhilippineSilver}, 0.1);
  border-radius: 28px;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
`;

interface OptionProps {
  $selected: boolean;
}

export const Icon = styled.div`
  width: 30px;
  height: 30px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Option = styled.div<OptionProps>`
  border-radius: 28px;
  -webkit-tap-highlight-color: transparent;
  padding: 5px 10px;
  transition: all 0.3s linear;
  background-color: ${({ $selected }) => ($selected ? ColorPalette.HEX.PineTree : ColorPalette.Transparent)};

  & ${Icon} .icons {
    color: ${({ $selected }) => ($selected ? ColorPalette.HEX.White : ColorPalette.HEX.DimGray2)};
  }
`;
